export const OPEN = 'DIALOG_OPEN';
export const CLOSE = 'DIALOG_CLOSE';
export const SET_ERRORS = 'DIALOG_SET_ERRORS';

export function open(elementId) {
    return {
        type: OPEN,
        elementId,
    };
};

export function close(elementId) {
    return {
        type: CLOSE,
        elementId,
    };
};

export function setErrors(errors, elementId) {
    return {
        type: SET_ERRORS,
        elementId,
        errors,
    };
};
